"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var coordinate_diagnosis_1 = require("../../../shared/model/coordinate-diagnosis");
var diagnosis_web_socket_service_1 = require("../../service/diagnosis-web-socket.service");
var attribute_state_1 = require("../../model/attribute-state");
var diagnosis_service_1 = require("../../service/diagnosis.service");
var accessory_range_1 = require("../../../shared/model/accessory-range");
var toast_service_1 = require("../../../shared/service/toast.service");
var CoordinateDiagnosisComponent = /** @class */ (function () {
    function CoordinateDiagnosisComponent(_diagnosisNotification, _diagnosiService, _toastService) {
        this._diagnosisNotification = _diagnosisNotification;
        this._diagnosiService = _diagnosiService;
        this._toastService = _toastService;
        this.coordinate = {};
        this.running = true;
        this.modalActions = new core_1.EventEmitter();
    }
    CoordinateDiagnosisComponent.prototype.ngOnInit = function () {
        if (this._run) {
            this.observeRestart();
            this.setEmptyEntities();
            this.subscribeCoordinateSuccess();
            this.subscribeCoordinateFail();
        }
        else {
            this.displayViewMode();
        }
    };
    Object.defineProperty(CoordinateDiagnosisComponent.prototype, "run", {
        get: function () {
            return this._run;
        },
        set: function (run) {
            this._run = run;
            if (!this._run) {
                this.loadingText = 'Indisponível';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CoordinateDiagnosisComponent.prototype, "coordinateDiagnosis", {
        get: function () {
            return this._coordinateDiagnosis;
        },
        set: function (coordinateDiagnosis) {
            this._coordinateDiagnosis = coordinateDiagnosis;
        },
        enumerable: true,
        configurable: true
    });
    CoordinateDiagnosisComponent.prototype.observeRestart = function () {
        var _this = this;
        this._diagnosisNotification.restart$
            .subscribe(function () {
            _this.setEmptyEntities();
            _this.running = true;
        });
    };
    CoordinateDiagnosisComponent.prototype.setEmptyEntities = function () {
        this.loadingText = 'Carregando...';
        this.accessoryRange = new accessory_range_1.AccessoryRange();
        this.accessoryRange.ranges = new Array();
        this.coordinateDiagnosis = new coordinate_diagnosis_1.CoordinateDiagnosis();
        this.coordinate = {};
        this.range = {};
        this.coordinate.canParams = {};
        this.coordinate.accessories = {};
    };
    CoordinateDiagnosisComponent.prototype.subscribeCoordinateSuccess = function () {
        var _this = this;
        this._diagnosisNotification.success$
            .filter(function (data) { return data instanceof coordinate_diagnosis_1.CoordinateDiagnosis; })
            .subscribe(function (coordinateDiagnosis) {
            _this.setAttributeState(coordinateDiagnosis, attribute_state_1.AttributeState.SUCCESS);
            _this.updateDiagnosisDisplay(coordinateDiagnosis);
            _this.loadingText = 'Indisponível';
        });
    };
    CoordinateDiagnosisComponent.prototype.subscribeCoordinateFail = function () {
        var _this = this;
        this._diagnosisNotification.failed$
            .filter(function (data) { return data instanceof coordinate_diagnosis_1.CoordinateDiagnosis; })
            .subscribe(function (coordinateDiagnosis) {
            _this.setAttributeState(coordinateDiagnosis, attribute_state_1.AttributeState.FAIL);
            _this.updateDiagnosisDisplay(coordinateDiagnosis);
            _this.loadingText = 'Indisponível';
        });
    };
    CoordinateDiagnosisComponent.prototype.disablePanic = function () {
        var _this = this;
        this._diagnosiService.disablePanic()
            .subscribe(function (success) { return _this.showMessage('Comando enviado.'); }, function (error) { return _this.showMessage('Error ao enviar comando.'); });
    };
    CoordinateDiagnosisComponent.prototype.blockVehicle = function () {
        var _this = this;
        this._diagnosiService.blockVehicle()
            .subscribe(function (success) { return _this.showMessage('Veículo bloqueado.'); }, function (error) { return _this.showMessage('Erro ao enviar comando de bloqueio.'); });
    };
    CoordinateDiagnosisComponent.prototype.openModal = function () {
        this.modalActions.emit({ action: 'modal', params: ['open'] });
    };
    CoordinateDiagnosisComponent.prototype.createAdmeasurement = function () {
        var _this = this;
        this.accessoryRange.ranges.push(this.range);
        this.accessoryRange.accessory = this.coordinateDiagnosis.accessories.RPM;
        this._diagnosiService.createAdmeasurement(this.accessoryRange)
            .subscribe(function (success) { return _this.showMessage('Aferição de RPM criada!'); }, function (error) { return _this.showMessage(JSON.parse(error._body).message); });
        this.modalActions.emit({ action: 'modal', params: ['close'] });
    };
    CoordinateDiagnosisComponent.prototype.closeModal = function () {
        this.modalActions.emit({ action: 'modal', params: ['close'] });
    };
    CoordinateDiagnosisComponent.prototype.getKeys = function (object) {
        return Object.keys(object);
    };
    CoordinateDiagnosisComponent.prototype.isSuccess = function (value) {
        return value === attribute_state_1.AttributeState.SUCCESS;
    };
    CoordinateDiagnosisComponent.prototype.updateDiagnosisDisplay = function (coordinateDiagnosis) {
        this.coordinateDiagnosis = coordinateDiagnosis;
        this.running = this.coordinateDiagnosis.isRunning;
    };
    CoordinateDiagnosisComponent.prototype.setAttributeState = function (coordinateResponse, state) {
        var _this = this;
        var accessoriesKey = 'accessories';
        var canParamsKey = 'canParams';
        Object.keys(coordinateResponse).forEach(function (key) {
            if (!(key in _this.coordinateDiagnosis) && key !== accessoriesKey && key !== canParamsKey) {
                _this.coordinate[key] = state;
            }
        });
        Object.keys(coordinateResponse.accessories).forEach(function (key) {
            if (!(key in _this.coordinateDiagnosis.accessories)) {
                _this.coordinate.accessories[key] = state;
            }
        });
        Object.keys(coordinateResponse.canParams).forEach(function (key) {
            if (!(key in _this.coordinateDiagnosis.canParams)) {
                _this.coordinate.canParams[key] = state;
            }
        });
    };
    CoordinateDiagnosisComponent.prototype.showMessage = function (message) {
        this._toastService.showMessage(message, 4000);
    };
    CoordinateDiagnosisComponent.prototype.displayViewMode = function () {
        this.range = {};
        this.coordinate = this._coordinateDiagnosis;
        this.setAccessories();
        this.setCanParams();
        var coord = this._coordinateDiagnosis;
        this._coordinateDiagnosis = this._coordinateDiagnosis.coordinateData;
        this.setStateOnAttribute(coord);
    };
    CoordinateDiagnosisComponent.prototype.setStateOnAttribute = function (source) {
        var _this = this;
        Object.keys(source).forEach(function (key) {
            if (key !== 'accessories' && key !== 'canParams' && key !== 'peripheralEvents') {
                if (source[key]) {
                    _this.coordinate[key] = attribute_state_1.AttributeState.SUCCESS;
                }
                else {
                    _this.coordinate[key] = attribute_state_1.AttributeState.FAIL;
                }
            }
        });
    };
    CoordinateDiagnosisComponent.prototype.setAccessories = function () {
        this.coordinate.accessories = { 'RPM': this._coordinateDiagnosis.rpmAccessory ? attribute_state_1.AttributeState.SUCCESS : attribute_state_1.AttributeState.FAIL,
            'PANIC': this._coordinateDiagnosis.panicAccessory ? attribute_state_1.AttributeState.SUCCESS : attribute_state_1.AttributeState.FAIL };
    };
    CoordinateDiagnosisComponent.prototype.setCanParams = function () {
        this.coordinate.canParams = { 'RPM': this._coordinateDiagnosis.rpm ? attribute_state_1.AttributeState.SUCCESS : attribute_state_1.AttributeState.FAIL,
            'Fuel Flow': this._coordinateDiagnosis.fuelFlow ? attribute_state_1.AttributeState.SUCCESS : attribute_state_1.AttributeState.FAIL,
            'Brake Status': this._coordinateDiagnosis.brakeStatus ? attribute_state_1.AttributeState.SUCCESS : attribute_state_1.AttributeState.FAIL,
            'Engine Brake': this._coordinateDiagnosis.engineBrake ? attribute_state_1.AttributeState.SUCCESS : attribute_state_1.AttributeState.FAIL,
            'Engine Failure': this._coordinateDiagnosis.engineFailure ? attribute_state_1.AttributeState.SUCCESS : attribute_state_1.AttributeState.FAIL,
            'Engine Temperature': this._coordinateDiagnosis.engineTemperature ? attribute_state_1.AttributeState.SUCCESS : attribute_state_1.AttributeState.FAIL,
            'Fuel Level': this._coordinateDiagnosis.fuelLevel ? attribute_state_1.AttributeState.SUCCESS : attribute_state_1.AttributeState.FAIL,
            'Hodometer': this._coordinateDiagnosis.hodometer ? attribute_state_1.AttributeState.SUCCESS : attribute_state_1.AttributeState.FAIL,
            'Secondary Hodometer': this._coordinateDiagnosis.secondaryHodometer ? attribute_state_1.AttributeState.SUCCESS : attribute_state_1.AttributeState.FAIL,
            'Total Engine Hour': this._coordinateDiagnosis.totalEngineHour ? attribute_state_1.AttributeState.SUCCESS : attribute_state_1.AttributeState.FAIL };
    };
    CoordinateDiagnosisComponent.ctorParameters = function () { return [{ type: diagnosis_web_socket_service_1.DiagnosisWebSocketService }, { type: diagnosis_service_1.DiagnosisService }, { type: toast_service_1.ToastService }]; };
    return CoordinateDiagnosisComponent;
}());
exports.CoordinateDiagnosisComponent = CoordinateDiagnosisComponent;
//# sourceMappingURL=coordinate-diagnosis.component.js.map


// WEBPACK FOOTER //
// coordinate-diagnosis.component.js